import GrievanceForm from "./GrievanceForm";
import {  AlertCircle, Shield, Clock, Headphones } from "lucide-react";

const Grievance = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="!absolute inset-0 opacity-10">
        <div className="!absolute top-0 left-0 w-full h-full"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 py-8 lg:py-12">
        <div className="grid lg:grid-cols-2 gap-0 bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl overflow-hidden">

          {/* Left Section - Information */}
          <div className="bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 text-white p-8 lg:p-12 relative overflow-hidden">
            {/* Decorative Elements */}
            <div className="!absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -translate-y-16 translate-x-16"></div>
            <div className="!absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-12 -translate-x-12"></div>

            <div className="relative z-10">
              <div className="inline-flex items-center bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 text-sm font-medium mb-6">
                <Shield className="w-4 h-4 mr-2 text-yellow-300" />
                <span>Secure & Confidential</span>
              </div>

              <h1 className="text-4xl lg:text-5xl font-bold mb-8 leading-tight">
                <span className="text-white">
                  Grievance
                </span>
                <br />
                <span className="text-white">Redressal</span>
              </h1>

              <div className="space-y-6 mb-8">
                <p className="!text-blue-100 text-lg leading-relaxed !text-left">
                  yslearn is committed to provide complete learner satisfaction.
                </p>

                <p className="!text-blue-100 leading-relaxed !text-left">
                  We have a dedicated team of associates to address grievances, feedback or queries from our learners regarding our online learning programs.
                </p>

                <p className="!text-blue-100 leading-relaxed !text-left">
                  If you have any complaints, feedback, or questions about our online learning programs, you may fill out this form or contact us using the information provided below.
                </p>
              </div>

              {/* Quick Stats */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                  <Clock className="w-8 h-8 text-yellow-300 mx-auto mb-2" />
                  <div className="text-2xl font-bold text-white">48hrs</div>
                  <div className="text-blue-200 text-sm">Response Time</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                  <Headphones className="w-8 h-8 text-yellow-300 mx-auto mb-2" />
                  <div className="text-2xl font-bold text-white">24/7</div>
                  <div className="text-blue-200 text-sm">Support</div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-yellow-400/20 to-orange-400/20 backdrop-blur-sm rounded-xl p-4 border border-yellow-300/30">
                <p className="!text-yellow-100 text-sm flex items-center">
                  <AlertCircle className="w-4 h-4 mr-2 flex-shrink-0" />
                  Rest assured we will respond to your concerns within 48 Business Hours.
                </p>
              </div>
            </div>
          </div>

          {/* Right Section - Form */}
            <GrievanceForm/>
        </div>
      </div>
    </div>
  );
};
export default Grievance;
